import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Announcements from '@components/individualPortal/dashboard/announcements/Announcements';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { useAnnouncements } from '@hooks/index';
import { useSelector } from 'react-redux';
import { ROOT_STATE } from '@store/store.types';

function EnrollerAnnouncements() {

    const { enrollerAnnouncements = [], isEnrollerAnnouncementsLoading, getEnrollerAnnouncements } = useAnnouncements();
    const impersonation = useSelector((state: ROOT_STATE) => state.common.environment.impersonation);
    
    useEffect(() => {
        getEnrollerAnnouncements();
    }, []);

    if (impersonation) {
        return null;
    }

    const hasAnnouncements = enrollerAnnouncements.length > 0;

    return (
        <div
            className={hasAnnouncements ? 'announcements' : undefined}
            data-testid="announcements-container"
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-busy={isEnrollerAnnouncementsLoading}
        >
            <ConditionalRendering isTrue={isEnrollerAnnouncementsLoading}>
                <span className="usa-sr-only">
                    <FormattedMessage id="common.loading" />
                </span>
            </ConditionalRendering>
            <ConditionalRendering isTrue={hasAnnouncements}>
                <Announcements announcements={enrollerAnnouncements} />
            </ConditionalRendering>

        </div>
    );
}

export default EnrollerAnnouncements;